module.exports = __webpack_public_path__ + "static/threejsproject-7e9456c1f560efca2496b7797fe4a413.png";